import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";

const MsalHandler = () => {
  const { instance } = useMsal();

  useEffect(() => {
    instance.handleRedirectPromise().then((response) => {
      if (response) {
        instance.setActiveAccount(response.account);
      }
    });
  }, [instance]);

  return null;
};

export default MsalHandler;
